import { AspectRatio, Image } from '@chakra-ui/react'
// import { Link } from 'react-router-dom';
import st_ac from "./AllCharities.module.css";

const Charity = ({ charityInfo }: any) => {

    return (
        <a href={charityInfo.disabled ? undefined : charityInfo.url} target="_blank">
            <AspectRatio ratio={1}>
                <div 
                style={{ 
                    backgroundImage: `url("${charityInfo.image}")`,
                    backgroundColor: charityInfo.backgroundColor,
                    cursor: charityInfo.disabled ? "default": "pointer"
                }}
                className={st_ac.indiv_charity}>
                    { charityInfo.disabled && <h1>{"Coming Soon"}</h1>}
                </div>
            </AspectRatio>
        </a>
    )
}

export default Charity;